import bloomlifeLogoUrl from "@/assets/bloomlife-logo-full.svg"
import measurementImageUrl from "@/assets/measurement.svg"
import { Button } from "@/components/chadcn/Button"
import HeroImage from "@/components/HeroImage"
import Page from "@/components/Page"
import { useState } from "react"
import SkipSetupModal from "../components/SkipSetupModal"

type DeviceReadyStepProps = {
  onNext: () => void
}

const DeviceReadyStep = ({ onNext }: DeviceReadyStepProps) => {
  const [isSkipModalOpen, setIsSkipModalOpen] = useState(false)

  return (
    <Page showAppbar={false}>
      <div className="flex min-h-page flex-col justify-between gap-6">
        <div className="flex flex-col items-center gap-6">
          <HeroImage src={measurementImageUrl} alt="health-measurement" />
          <img alt="logo" src={bloomlifeLogoUrl} width="230" />
          <h2 className="text-center text-h2 text-primary-contrast">
            Ready to set up your connected blood glucose monitor?
            <br />
            <br />
            Make sure you have the monitor on hand for the next few steps
          </h2>
        </div>
        {/* TODO: Add a blood pressure device button once hypertension is supported */}
        <div className="flex flex-col gap-3">
          <Button type="button" className="w-full py-2 text-base" onClick={onNext}>
            I have my blood glucose device!
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full py-2 text-base"
            onClick={() => setIsSkipModalOpen(true)}
          >
            Not ready yet
          </Button>
        </div>
        <SkipSetupModal open={isSkipModalOpen} onClose={() => setIsSkipModalOpen(false)} />
      </div>
    </Page>
  )
}

export default DeviceReadyStep
